import type { ResponseSpacing, Spacing } from '@athena-lib/spacing';
import type { Snippet } from 'svelte';
import type { Action } from 'svelte/action';

export type AccordionProps = {
  singleOpen?: boolean;
  space?: Spacing | ResponseSpacing;
  children: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
};

export type AccordionItemProps = {
  heading: string;
  children: Snippet;
  class?: string;
};

export const contextKey = Symbol('athena-accordion');

export type AccordionContext = {
  toggle: (heading: string) => void;
  isOpen: (heading: string) => boolean;
};
